// extracted by mini-css-extract-plugin
module.exports = {"user-avatar":"_2nBVY","userAvatar":"_2nBVY","pixelated":"orxzh"};